// eslint-disable-next-line import/prefer-default-export
export const getToasts = state => state.toasts;
